import React from 'react';
import { Form, Collapse, Button, FormGroup } from 'reactstrap';
import { ChevronDoubleUp, ChevronDoubleDown } from 'react-bootstrap-icons';

export const CollapsibleSection = ({ title, isOpen, onToggle, children }) => (
    <Form className="calcForm bg-light">
        <div className="sectionHeader">
            <span>{title}</span>
            <Button onClick={onToggle} className='btn-toggle'>
                {!isOpen ? <ChevronDoubleDown className="toggleImage" /> : <ChevronDoubleUp className="toggleImage" />}
            </Button>
        </div>
        <Collapse isOpen={isOpen}>
            <FormGroup>
                {children}
            </FormGroup>
        </Collapse>
    </Form>
);